import { Box, CircularProgress } from '@mui/material';
import { useEffect, useRef } from 'react';
import {
  completeHubSignIn,
  HUB_CALLBACK_PATH,
  HubSignInError,
  setHubSignInError,
} from '../../services/hubAuth';
import { reportMonitoredError } from '../../services/sentry';

const GENERIC_ERROR = 'Sign-in with Enara Hub failed. Please try again.';

export const HubCallback = () => {
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const search = window.location.search;
    // The code must not linger in history or in anything that reads the URL later
    window.history.replaceState(null, '', HUB_CALLBACK_PATH);

    completeHubSignIn(search)
      .then(() => window.location.replace('/'))
      .catch((error) => {
        if (!(error instanceof HubSignInError)) reportMonitoredError({ error });
        setHubSignInError(error instanceof HubSignInError ? error.message : GENERIC_ERROR);
        window.location.replace('/#/login');
      });
  }, []);

  return (
    <Box display='flex' alignItems='center' justifyContent='center' minHeight='100vh'>
      <CircularProgress />
    </Box>
  );
};
